// Human docs and the agent entry point live in the replayio/docs repo (docs.replay.io).
export const DOCS_URL = 'https://docs.replay.io'
export const AGENT_ENTRY_URL = `${DOCS_URL}/llms.txt`

// The one pointer users hand their coding agent; the agent entry point owns every API detail.
export const AGENT_PROMPT = `Use Replay QA to test and fix this app. Start at ${AGENT_ENTRY_URL} and follow it.`
